import { TRole } from "~/types/Routes";

type TAccess = TRole[];

type TRoles = {
  adminData: TRole;
  admin: TRole;
  leader: TRole;
  holding: TRole;
  dealer: TRole;
  leaderRegionalSalesManager: TRole;
  leaderRegionalServiceManager: TRole;
  regionalSalesManager: TRole;
  regionalServiceManager: TRole;
  checker: TRole;
  autovaz: TRole;
  bank: TRole;
};
export const Roles: TRoles = {
  adminData: "adminData", //Администратор данных
  admin: "admin", //Администратор
  leader: "leader", //Руководитель
  holding: "holding", //Холдинг
  dealer: "dealer", //Дилер
  leaderRegionalSalesManager: "leaderRegionalSalesManager", //Руководитель региональных менеджеров по продажам
  leaderRegionalServiceManager: "leaderRegionalServiceManager", //Руководитель региональных менеджеров по сервису
  regionalSalesManager: "regionalSalesManager", //Региональный менеджер по продажам
  regionalServiceManager: "regionalServiceManager", //Региональный менеджер по сервису
  checker: "checker", //сотрудник УОСОА - Управление организации сервисного обслуживания автомобилей
  autovaz: "autovaz", // Сотрудник АВТОВАЗ
  bank: "bank", // Сотрудник Банка
};

export const SRR_ROUTE_ACCESS: TAccess = [
  Roles.adminData,
  Roles.admin,
  Roles.leader,
  Roles.holding,
  Roles.dealer,
  Roles.leaderRegionalSalesManager,
  Roles.leaderRegionalServiceManager,
  Roles.regionalSalesManager,
  Roles.regionalServiceManager,
  Roles.checker,
];
